import { Component, OnInit } from '@angular/core';
import templateString from './selfRosteringMemberships.component.html';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SelfRosteringMembershipFormComponent } from '../selfRosteringMembershipForm';
import { EnvironmentService } from '../../../environment.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Task } from '../../../models/task.model';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Component({
  standalone: false,
  template: templateString
})
export class SelfRosteringMembershipsComponent implements OnInit {
    public destroyed$: any;
    public isLoading: boolean;
    public accumulationPeriod: any;
    public selectedSchedulePeriod: any;
    public candidateTypes: any;
    public tasks: any;
    public isSuperAdmin: any;
    public customer: any;
    public selfRosteringStartDate: any;

    constructor(
        private http: HttpClient,
        private bsModalService: BsModalService,
        private environmentService: EnvironmentService
	) { 
        this.destroyed$ = new Subject<boolean>();
    }

	refresh() {
        var self = this;

        this.isLoading = true;

        this.http.get("candidate_types").subscribe(x => {
			this.candidateTypes = x;
			
			if (this.candidateTypes.length > 0) {
                this.http.get("tasks/index_for_self_rostering_memberships", 
                    { 
                        params: {
                            schedule_period_id: this.selectedSchedulePeriod.id, 
                        }
                    }
                ).subscribe(tasks => {
					this.tasks = tasks;

                    this.tasks.forEach(function(task) {
                        task.computedName = (new Task(task)).getComputedName();
                        
                        task.self_rostering_memberships_dictionary = {}
                        self.candidateTypes.forEach(function(candidateType) { 
                            task.self_rostering_memberships_dictionary[candidateType.id] = 
                                task.self_rostering_memberships.filter(function(x) { return x.candidate_type_id == candidateType.id }).length > 0;
                        });
					});
					
					this.isLoading = false;
				});
			} else {
				this.tasks = [];
				this.isLoading = false;
			}
		});

        this.http.get<any>("customers/" +  this.customer.id.toString()).subscribe(x => {
            this.selfRosteringStartDate = x.self_rostering_start_date ? moment(x.self_rostering_start_date) : null;
        });
    }

    edit() {
        console.log(this.selfRosteringStartDate);
        var bsModalRef = this.bsModalService.show(SelfRosteringMembershipFormComponent, {
            initialState: {
                candidateTypes: this.candidateTypes,
                tasks: this.tasks,
                selfRosteringStartDate: this.selfRosteringStartDate
            },
            class: 'xlModal'
        });

        bsModalRef.content.action.subscribe(result => {
			this.refresh();
        });
    }

	initialize() {
        this.isLoading = true;
		
 		this.selectedSchedulePeriod = this.environmentService.getSchedulePeriodSelection();
		
        this.isSuperAdmin = this.environmentService.getUser().isSuperAdmin;
 		this.customer = this.environmentService.getUser().customer;
		
 		this.refresh();
 	}
		
    ngOnInit() {
        this.environmentService.selectedSchedulePeriodChanged$
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => {
                this.initialize();
            });

        this.initialize();
    }

    ngOnDestroy() {
		this.destroyed$.next();
		this.destroyed$.complete();
    }
}
